export const TOURNEE_MODELE = {
  lecture: { module: 'logistique', element: 'tournee_modele', rule: 'lecture' },
  maj: { module: 'logistique', element: 'tournee_modele', rule: 'maj' },
  exporter: { module: 'logistique', element: 'tournee_modele', rule: 'exporter' },
  supprimer: { module: 'logistique', element: 'tournee_modele', rule: 'supprimer' },
};

export const AFFICHEUR = {
  lecture: { module: 'logistique', element: 'afficheur', rule: 'lecture' },
  maj: { module: 'logistique', element: 'afficheur', rule: 'maj' },
  exporter: { module: 'logistique', element: 'afficheur', rule: 'exporter' },
  supprimer: { module: 'logistique', element: 'afficheur', rule: 'supprimer' },
};

export const DEMANDE = {
  lecture: { module: 'logistique', element: 'demande', rule: 'lecture' },
  maj: { module: 'logistique', element: 'demande', rule: 'maj' },
  exporter: { module: 'logistique', element: 'demande', rule: 'exporter' },
  supprimer: { module: 'logistique', element: 'demande', rule: 'supprimer' },
};

export const AFFECTATION = {
  lecture: { module: 'logistique', element: 'affectation', rule: 'lecture' },
  maj: { module: 'logistique', element: 'affectation', rule: 'maj' },
  exporter: { module: 'logistique', element: 'affectation', rule: 'exporter' },
  supprimer: { module: 'logistique', element: 'affectation', rule: 'supprimer' },
};

export const CHARGE_TRAVAIL = {
  lecture: { module: 'logistique', element: 'charge_travail', rule: 'lecture' },
  maj: { module: 'logistique', element: 'charge_travail', rule: 'maj' },
  exporter: { module: 'logistique', element: 'charge_travail', rule: 'exporter' },
  supprimer: { module: 'logistique', element: 'charge_travail', rule: 'supprimer' },
};

export const ORDRE_TRAVAIL = {
  lecture: { module: 'logistique', element: 'ordre_travail', rule: 'lecture' },
  maj: { module: 'logistique', element: 'ordre_travail', rule: 'maj' },
  exporter: { module: 'logistique', element: 'ordre_travail', rule: 'exporter' },
  supprimer: { module: 'logistique', element: 'ordre_travail', rule: 'supprimer' },
  editer: { module: 'logistique', element: 'ordre_travail', rule: 'edition' },
};

export const INTERVENTION = {
  lecture: { module: 'logistique', element: 'demande_intervention', rule: 'lecture' },
  maj: { module: 'logistique', element: 'demande_intervention', rule: 'maj' },
  exporter: { module: 'logistique', element: 'demande_intervention', rule: 'exporter' },
  supprimer: { module: 'logistique', element: 'demande_intervention', rule: 'supprimer' },
};

export const TECHNICIEN = {
  lecture: { module: 'logistique', element: 'technicien', rule: 'lecture' },
  maj: { module: 'logistique', element: 'technicien', rule: 'maj' },
  exporter: { module: 'logistique', element: 'technicien', rule: 'exporter' },
  supprimer: { module: 'logistique', element: 'technicien', rule: 'supprimer' },
};

export const TYPE_OT = {
  lecture: { module: 'logistique', element: 'type_ot', rule: 'lecture' },
  maj: { module: 'logistique', element: 'type_ot', rule: 'maj' },
  exporter: { module: 'logistique', element: 'type_ot', rule: 'exporter' },
  supprimer: { module: 'logistique', element: 'type_ot', rule: 'supprimer' },
};

export const PROJETS = {
  lecture: { module: 'logistique', element: 'projets', rule: 'lecture' },
  maj: { module: 'logistique', element: 'projets', rule: 'maj' },
  exporter: { module: 'logistique', element: 'projets', rule: 'exporter' },
  supprimer: { module: 'logistique', element: 'projets', rule: 'supprimer' },
};
export const PREVISIONNEL_DEPART = {
  lecture: { module: 'logistique', element: 'previsionnel', rule: 'lecture' },
  maj: { module: 'logistique', element: 'previsionnel', rule: 'maj' },
  exporter: { module: 'logistique', element: 'previsionnel', rule: 'exporter' },
  supprimer: { module: 'logistique', element: 'previsionnel', rule: 'supprimer' },
};

export const ORDRE_TRAVAIL_AUDIT = {
  lecture: { module: 'logistique', element: 'ordre_travail_audit', rule: 'lecture' },
  maj: { module: 'logistique', element: 'ordre_travail_audit', rule: 'maj' },
  exporter: { module: 'logistique', element: 'ordre_travail_audit', rule: 'exporter' },
  supprimer: { module: 'logistique', element: 'ordre_travail_audit', rule: 'supprimer' },
};

export const DEMANDE_IMPRESSION = {
  lecture: { module: 'logistique', element: 'demande_impression', rule: 'lecture' },
  maj: { module: 'logistique', element: 'demande_impression', rule: 'maj' },
  exporter: { module: 'logistique', element: 'demande_impression', rule: 'exporter' },
  supprimer: { module: 'logistique', element: 'demande_impression', rule: 'supprimer' },
};

export const ORDRE_TRAVAIL_EXPEDITION = {
  lecture: { module: 'logistique', element: 'ordre_travail_expedition', rule: 'lecture' },
  maj: { module: 'logistique', element: 'ordre_travail_expedition', rule: 'maj' },
  exporter: { module: 'logistique', element: 'ordre_travail_expedition', rule: 'exporter' },
  supprimer: { module: 'logistique', element: 'ordre_travail_expedition', rule: 'supprimer' },
};

export const ORDRE_TRAVAIL_IMPRESSION = {
  lecture: { module: 'logistique', element: 'ordre_travail_impression', rule: 'lecture' },
  maj: { module: 'logistique', element: 'ordre_travail_impression', rule: 'maj' },
  exporter: { module: 'logistique', element: 'ordre_travail_impression', rule: 'exporter' },
  supprimer: { module: 'logistique', element: 'ordre_travail_impression', rule: 'supprimer' },
  editer: { module: 'logistique', element: 'ordre_travail_impression', rule: 'edition' },
};

export const SUIVI_PRODUCTION = {
  lecture: { module: 'logistique', element: 'suivi_production', rule: 'lecture' },
  maj: { module: 'logistique', element: 'suivi_production', rule: 'maj' },
  exporter: { module: 'logistique', element: 'suivi_production', rule: 'exporter' },
  supprimer: { module: 'logistique', element: 'suivi_production', rule: 'supprimer' },
};

export const BON_EXPEDITION = {
  lecture: { module: 'logistique', element: 'bon_expedition', rule: 'lecture' },
  maj: { module: 'logistique', element: 'bon_expedition', rule: 'maj' },
  exporter: { module: 'logistique', element: 'bon_expedition', rule: 'exporter' },
  supprimer: { module: 'logistique', element: 'bon_expedition', rule: 'supprimer' },
  editer: { module: 'logistique', element: 'bon_expedition', rule: 'edition' },
};
